import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="dashboard--stream"
//
// Cable caído, Sidekiq morto ou cron parado dão o mesmo sintoma na tela de
// parede: número velho com cara de atual. Em vez de depender de um atributo
// de conexão do Turbo (esta versão não seta nenhum em <turbo-cable-stream-source>),
// detecta silêncio: sem <turbo-stream> chegando por tempo demais, recarrega
// o frame do cache.

// 3x o intervalo do cron (5 min) — se o cron mudar, ajustar aqui.
const SILENCE_THRESHOLD_MS = 15 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;

export default class extends Controller {
  static get values() {
    return { src: String };
  }

  connect() {
    this.lastStreamAt = Date.now();
    this.onStreamRender = this.onStreamRender.bind(this);
    document.addEventListener(
      'turbo:before-stream-render',
      this.onStreamRender
    );
    this.timer = setInterval(() => this.checkSilence(), CHECK_INTERVAL_MS);
  }

  disconnect() {
    document.removeEventListener(
      'turbo:before-stream-render',
      this.onStreamRender
    );
    clearInterval(this.timer);
  }

  onStreamRender() {
    this.lastStreamAt = Date.now();
  }

  checkSilence() {
    if (Date.now() - this.lastStreamAt > SILENCE_THRESHOLD_MS) {
      // 1ª recuperação: o frame nasce sem src, então setar já dispara o
      // fetch. Da 2ª em diante o valor já está lá — setar o mesmo valor de
      // novo não garante refetch, então usa reload() (que o próprio Turbo
      // implementa limpando o src e reatribuindo antes de buscar de novo).
      if (this.element.src) {
        this.element.reload();
      } else {
        this.element.src = this.srcValue;
      }
      this.lastStreamAt = Date.now();
    }
  }
}
